import React, {Component} from 'react'
import {Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap";
import Swal from "sweetalert2";
import {withTourGuide} from "../../../guideComponent/withTourGuide";

class AddFinanceTerm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      prosesSimpan: false
    }
    this.triggerGuideOnce = this.triggerGuideOnce.bind(this)
  }

  triggerGuideOnce = (e, config) => {
    const { showGuide, isGuideActive, disabledKeys } = this.props;

    const target = e?.currentTarget ?? null;
    if (!target || !config?.key) return;
    if (disabledKeys?.includes(config.key)) return;
    if (isGuideActive) return;
    if (typeof showGuide !== 'function') return;
    showGuide(target, config);
  };

  handleAdd = () => {
    this.setState({ prosesSimpan: true})
    let form = {
      fin_term_name: this.state.fin_term_name,
      fin_term_type: this.state.fin_term_type
    }
    this.props.request("finance_term/add", form, 'POST')
      .then((response) => {
        if (response && response.success) {
          this.props.changeState({
            modal_add: false,
          }, () => this.props.loadData())
          Swal.fire({
            title: 'Berhasil!',
            text: response.message,
            icon: 'success',
            confirmButtonText: 'OK'
          })
        } else if (response) {
          Swal.fire({
            title: 'Gagal!',
            text: response.message,
            icon: 'warning',
            confirmButtonText: 'OK'
          })
        }
        this.setState({
          fin_term_name: '',
          fin_term_type: '',
          prosesSimpan: false
        })
      })
  }

  render() {
    return (
      <Modal isOpen={this.props.modal_add} toggle={() => this.props.changeState({ modal_add: false })} style={{ maxWidth: "1000px"}} zIndex={999}>
        <ModalHeader className="pengumuman-modal-header" toggle={() => this.props.changeState({ modal_add: false })}>
          <div className='presensi-modal-title'>Tambah Istilah Keuangan</div>
        </ModalHeader>
        <ModalBody className="pengumuman-modal-body">
              <div className="row p-3">
                  <div className="col">
                      <div className="form-group">
                          <label className="pengumuman-label-input" htmlFor="exampleFormControlInput1">
                              Nama Istilah Keuangan
                          </label>
                          <input className="form-control col-xl-12 col-md-12"
                                 placeholder="Masukkan nama istilah keuangan"
                                 type="text" required=""
                                 onChange={(e) => this.setState({fin_term_name: e.target.value})}
                                 onPointerEnter={(e) => {
                                     this.triggerGuideOnce(e, {
                                         key: "namaIstilahKeuangan",
                                         title: "Nama Istilah Keuangan",
                                         content: "Masukkan nama istilah keuangan yang ingin ditambahkan, misalnya 'Gaji Pokok' atau 'Tunjangan Transport'."
                                     });
                                 }}
                          />
                      </div>
                      <div className="form-group">
                          <label className="pengumuman-label-input" htmlFor="exampleFormControlInput1">
                              Tipe Istilah Keuangan
                          </label>
                          <select
                              className="form-control col-xl-12 col-md-12"
                              onChange={(e) => this.setState({fin_term_type: e.target.value})}
                              onPointerEnter={(e) => {
                                  this.triggerGuideOnce(e, {
                                      key: "tipeIstilahKeuangan",
                                      title: "Tipe Istilah Keuangan",
                                      content: "Pilih tipe istilah keuangan. Pilih 'Income' untuk pemasukan atau 'Outcome' untuk pengeluaran."
                                  });
                              }}
                          >
                              <option value="">Pilih Tipe</option>
                              <option value="income">income</option>
                              <option value="outcome">outcome</option>
                          </select>
                      </div>
                  </div>
              </div>
          </ModalBody>
        <ModalFooter className="pengumuman-modal-footer">
          <button
            onClick={() => this.props.changeState({modal_add: false})}
            className='btn text-capitalize batalkan-add-jamker'>Batal
          </button>
          <button
            className='btn btn-primary text-capitalize' disabled={this.state.prosesSimpan}
            style={{padding: "8px 14px", fontWeight: 500, fontSize: "14px", lineHeight: "24px"}}
            onClick={this.handleAdd}>{this.state.prosesSimpan ? "Menyimpan" : "Simpan"}
          </button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default withTourGuide(AddFinanceTerm);